(function(){
  // Feedback táctil y respaldo para enlaces vacíos
  document.addEventListener('pointerdown',function(e){
    var b=e.target.closest('a,button,[role="button"]');if(!b)return;
    b.classList.add('ak-pressed');setTimeout(function(){b.classList.remove('ak-pressed')},160);
    if(navigator.vibrate&&e.pointerType==='touch'){try{navigator.vibrate(8)}catch(_){}}
  },{passive:true});
  document.addEventListener('click',function(e){
    var a=e.target.closest('a');if(!a||a.id==='more-payment-options-link'||a.closest('.shopify-payment-button,[data-shopify]')||e.defaultPrevented)return;
    var h=(a.getAttribute('href')||'').trim();
    if(h===''||h==='#'||/^javascript:/i.test(h)){
      var t=(a.textContent||'').toLowerCase();
      var dest=/whats|asesor|escr[ií]benos/.test(t)?'https://wa.me/573217505619?text='+encodeURIComponent('Hola ASSKEO NUTRITION, quiero asesoría para elegir mi suplemento'):/contact/.test(t)?'/pages/contact':/prote/.test(t)?'/collections/proteinas':/creatin/.test(t)?'/collections/creatinas':/pre/.test(t)?'/collections/pre-entrenos':/vitamin|omega/.test(t)?'/collections/vitaminas-y-omega':'/collections/all';
      if(a.getAttribute('aria-haspopup')||a.closest('[role="tablist"]'))return;
      e.preventDefault();if(/^https?:/.test(dest))window.open(dest,'_blank','noopener');else location.href=dest;
    }
  });
})();
